module.exports = __webpack_public_path__ + "img/payment-logos-clearbank.57dbc932.png";